/**
 * TIPS AND TRICKS FOR CONTRIBUTORS
 * 1) Memorize the layering of body parts. Hands are higher than arms, feet higher than legs
 * 2) Generally you will want to avoid lower pri items on the same layer sticking out on seams if your object is skintight.
 * In general, this is accomplished by having higher priority items cover more of the original
 */



AddModel({
	Name: "SlayerCollar",
	Folder: "Slayer",
	Parent: "SlayerCape",
	TopLevel: true,
	Categories: ["Accessories"],
	Layers: ToLayerMap([
		{ Name: "CapeCollar", Layer: "Collar", Pri: 54,
			Invariant: true,
			NoOverride: true,
		},
		{ Name: "CapeCollarButton", Layer: "Collar", Pri: 54.1,
			Invariant: true,
			InheritColor: "Button",
			NoOverride: true, TieToLayer: "CapeCollar",
		},
		{ Name: "CapeCollarRim", Layer: "Collar", Pri: 54.1,
			Invariant: true,
			InheritColor: "Rim",
			NoOverride: true, TieToLayer: "CapeCollar",
		},
	])
});
AddModel({
	Name: "SlayerCape",
	Folder: "Slayer",
	TopLevel: true,
	Categories: ["Accessories"],
	Layers: ToLayerMap([
		...GetModelLayers("SlayerCollar"),
		{ Name: "CapeCollarInner", Layer: "Collar", Pri: 54.1,
			Invariant: true,
			InheritColor: "Inner",
			NoOverride: true, TieToLayer: "CapeCollar",
		},
		{ Name: "Cape", Layer: "Shoulders", Pri: 35,
			Poses: ToMap([...ARMPOSES]),
			InheritColor: "Cape",
			NoOverride: true,
			Invariant: true,
			MorphPoses: {Tied: "Tied", Crossed: "Tied", Front: "Tied", Up: "Up", Yoked: "Yoked"},
		},
		{ Name: "CapeStripe", Layer: "Shoulders", Pri: 35.1,
			Poses: ToMap([...ARMPOSES]),
			InheritColor: "Stripe",
			TieToLayer: "Cape",
			NoOverride: true,
			Invariant: true,
			MorphPoses: {Tied: "Tied", Crossed: "Tied", Front: "Tied", Up: "Up", Yoked: "Yoked"},
		},
		{ Name: "CapeShoulderLeft", Layer: "Shoulders", Pri: 35.1,
			Poses: ToMap([...ARMPOSES]),
			InheritColor: "ShoulderLeft",
			TieToLayer: "Cape",
			NoOverride: true,
			Invariant: true,
			MorphPoses: {Tied: "Tied", Crossed: "Tied", Front: "Tied", Up: "Up", Yoked: "Yoked"},
		},
		{ Name: "CapeShoulderRight", Layer: "Shoulders", Pri: 35.1,
			Poses: ToMap([...ARMPOSES]),
			InheritColor: "ShoulderRight",
			TieToLayer: "Cape",
			NoOverride: true,
			Invariant: true,
			MorphPoses: {Tied: "Tied", Crossed: "Tied", Front: "Tied", Up: "Up", Yoked: "Yoked"},
		},
		{ Name: "CapeShoulderLeftButton", Layer: "Shoulders", Pri: 35.2,
			Poses: ToMap([...ARMPOSES]),
			InheritColor: "LeftButton",
			TieToLayer: "Cape",
			NoOverride: true,
			Invariant: true,
			MorphPoses: {Tied: "Tied", Crossed: "Tied", Front: "Tied", Up: "Up", Yoked: "Yoked"},
		},
		{ Name: "CapeShoulderRightButton", Layer: "Shoulders", Pri: 35.2,
			Poses: ToMap(["Up"]),
			InheritColor: "RightButton",
			TieToLayer: "Cape",
			NoOverride: true,
		},
		{ Name: "CapeBack", Layer: "Cape", Pri: -35,
			Poses: ToMap(["Yoked", "Up"]),
			InheritColor: "Back",
		},
	])
});